
import React from 'react';
import BikeDetailsCard from '@/components/courier/BikeDetailsCard';
import { RentalInfo } from '@/hooks/types/rentalTypes';
import { ActiveRentalCard } from '@/components/courier/ActiveRentalCard';
import { TariffInfoCard } from '@/components/courier/TariffInfoCard';
import { LocationCard } from '@/components/courier/LocationCard';
import { PaymentsCard } from '@/components/courier/PaymentsCard';
import { QuickActionsCard } from '@/components/courier/QuickActionsCard';
import { RentalHistoryCard } from '@/components/courier/RentalHistoryCard';
import { useIsMobile } from '@/hooks/use-mobile';

interface DashboardMainGridProps {
  currentRental: RentalInfo | null;
  rentals: RentalInfo[];
  bikeDetails: any; // Добавляем данные о велосипеде
  loading: boolean;
  rentalsLoading: boolean;
  bikeLoading: boolean;
  payments?: any[]; // Добавляем данные о платежах
  totalPaid?: number; // Добавляем общую сумму платежей
  paymentsLoading?: boolean; // Добавляем состояние загрузки платежей
  onBikeUpdate?: () => void; // Добавляем колбэк для обновления данных велосипеда
}

export const DashboardMainGrid: React.FC<DashboardMainGridProps> = ({
  currentRental,
  rentals,
  bikeDetails,
  loading,
  rentalsLoading,
  bikeLoading,
  payments = [],
  totalPaid = 0,
  paymentsLoading = false,
  onBikeUpdate
}) => {
  const isMobile = useIsMobile();
  
  console.log('Рендер DashboardMainGrid:', { 
    isMobile, 
    payments: payments?.length, 
    totalPaid,
    bikeModel: bikeDetails?.model 
  });
  
  const gap = isMobile ? 'gap-3' : 'gap-4 md:gap-6';
  const marginTop = isMobile ? 'mt-3' : 'mt-4 md:mt-6';
  
  return (
    <>
      <div className={`grid grid-cols-1 md:grid-cols-2 ${gap}`}>
        <ActiveRentalCard 
          rental={currentRental}
          loading={rentalsLoading || loading}
        />
        
        <TariffInfoCard 
          rental={currentRental}
          loading={rentalsLoading || loading}
        />
      </div>
      
      <div className={`grid grid-cols-1 md:grid-cols-2 ${gap} ${marginTop}`}>
        <BikeDetailsCard 
          bikeDetails={bikeDetails}
        />
        
        <PaymentsCard 
          payments={payments}
          totalPaid={totalPaid}
          loading={paymentsLoading}
        />
      </div>
      
      <div className={`grid grid-cols-1 md:grid-cols-2 ${gap} ${marginTop}`}>
        <RentalHistoryCard 
          rentals={rentals}
          loading={rentalsLoading || loading}
        />
        
        <QuickActionsCard 
          bikeDetails={bikeDetails}
          onBikeUpdate={onBikeUpdate}
        />
      </div>
    </>
  );
};
